import { useSiteSettings, type MenuSection, type MenuItemKey } from '../context/SiteSettingsContext';

export type { MenuSection, MenuItemKey };

export function useMenuVisibility() {
  const { visibility, toggleVisibility, setVisibilityAll, resetVisibility, loading, error, refresh } = useSiteSettings();

  return {
    state: visibility,
    toggle: toggleVisibility,
    setAll: setVisibilityAll,
    reset: resetVisibility,
    isVisible: (section: MenuSection, key: MenuItemKey) => visibility[section]?.[key] ?? true,
    loading,
    error,
    refresh
  };
}